<evrideo-destination-youtube-settings
  [catalog]="catalog"
  [platformData]="platformData"
  [readonly]="readonly"
  appearance="clipping-sidebar"
  (platformDataChange)="onPlatformDataChange($event)"
></evrideo-destination-youtube-settings>
